import { useLocalStorage } from '@rehooks/local-storage';
import { getVisibleColumnsKey, createColumnHash, createStorageHashKey } from '../../utils';
export var useVisibleColumns = function (listID) {
    var storageColumnsKey = getVisibleColumnsKey(listID);
    var storageHashKey = createStorageHashKey(listID);
    var _a = useLocalStorage(storageHashKey), columnsHash = _a[0], setColumnsHash = _a[1];
    var _b = useLocalStorage(storageColumnsKey), _c = _b[0], cachedColumns = _c === void 0 ? [] : _c, setCachedColumns = _b[1];
    var setDefaultVisibleColumns = function (defaultColumns) {
        if (defaultColumns === void 0) { defaultColumns = []; }
        var newColumnsHash = createColumnHash(defaultColumns);
        var isDefaultColumnsChanged = columnsHash !== newColumnsHash;
        if (isDefaultColumnsChanged) {
            // We updated hash and reset all cashed columns to default stated
            setColumnsHash(newColumnsHash);
            setCachedColumns(defaultColumns);
        }
        else {
            // We ignore default columns and work with cashed if they exists
            setCachedColumns(cachedColumns !== null && cachedColumns !== void 0 ? cachedColumns : defaultColumns);
        }
    };
    var handleColumnsChange = function (_a) {
        var values = _a.values;
        // There is always should be at least one selected column
        if (values.length === 0) {
            return;
        }
        setCachedColumns(values);
    };
    return {
        setDefaultVisibleColumns: setDefaultVisibleColumns,
        handleColumnsChange: handleColumnsChange,
        visibleColumns: cachedColumns,
    };
};
